import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e0dda9be&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=e0dda9be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0dda9be",
  null
  
)

export default component.exports